// Added by Sejune Oh on 2019-06-30
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Store
import RootStore from '../..'
import MgmtStoreBase from '../../base/MgmtStoreBase'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export interface DicomScpRulesetBaseProps {
    macro_values?: Array<string>
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default class DicomScpRulesetBase extends MgmtStoreBase<DicomScpRulesetBaseProps> {
    root?: RootStore

    constructor(root: RootStore) {
        super({ storeName: 'DicomScpRulesetBase', apiUrl: 'mgmt/dicomscp-rulesets', _root: root })
        this.root = root
    }

    getMacroTags = async () => {
        const { macro_values } = await super.getSingleWithoutId(`/macros/tags`)
        return macro_values
    }

    getMacroTypes = async () => {
        const { macro_values } = await super.getSingleWithoutId('/macros/types')
        return macro_values
    }

    getMacroFunctions = async () => {
        const { macro_values } = await super.getSingleWithoutId('/macros/functions')
        return macro_values
    }
}
